export type { ContentType } from "features/cases/contentType";
export { CONTENT_TYPES, isValidContentType } from "features/cases/contentType";

export const CONTENT_STATUSES = ["queue", "moderated", "deleted"] as const;

export type ContentStatus = (typeof CONTENT_STATUSES)[number];

export const isValidContentStatus = (value: string): value is ContentStatus =>
  CONTENT_STATUSES.includes(value as ContentStatus);

export const MODERATORIAL_CASES_QUERY_KEY = "moderatorial/cases";
